import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewChild,
} from '@angular/core';
import { ScheduleModel, ScheduleRange } from '@models/schedule.model';
import { TogglerModel } from '@models/toggler.model';
import { DateHelperService } from 'app/providers/helpers/helpers';
import { MeetingService } from '@services/metting.service';
import { MeetingModel } from '@models/meeting.model';
import { CalendarComponent } from 'on-wac-ui-lib';
import { CRUDService } from '@services/api-calls/crud.service';
import { Coordinator } from '@models/deal.model';

@Component({
    selector: 'app-meeting-selector',
    templateUrl: './meeting-selector.component.html',
    styleUrls: ['./meeting-selector.component.scss'],
})
export class MeetingSelectorComponent implements OnInit {
    public currentDate: Date = new Date();
    public currentCalendarYear: number;
    public monthSchedule: ScheduleModel[];
    public schedule: ScheduleModel;
    public selectedRange: ScheduleRange;
    public selectedDay: Date;
    public excludedDays: Date[] = [];
    public meetingID: number;

    @Input() toggler: TogglerModel;
    @Input() coordinator: Coordinator;
    @Output() onArrangeDate = new EventEmitter<any>();
    @ViewChild(CalendarComponent, { static: false })
    owCalendarChild: CalendarComponent;

    constructor(
        private dateHelper: DateHelperService,
        private crudService: CRUDService
    ) {}

    ngOnInit(): void {
        this.currentCalendarYear = this.currentDate.getFullYear();
        this.getMonthSchedule(this.currentDate, true);
    }

    onCalendarChange(event: any) {
        let updateUnavailableDays: boolean = false;
        if (event.currentYear != this.currentCalendarYear) {
            this.currentCalendarYear = event.currentYear;
            updateUnavailableDays = true;
        }
        this.getMonthSchedule(event.date, updateUnavailableDays);
    }

    getMonthSchedule(date: Date, updateUnavailableDays: boolean = false): void {
        this.excludedDays = [];
        const firstDay = `${date.getFullYear()}-${date.getMonth() + 1}-01`;
        this.crudService
            .run('read', 'meetings/scheduler', 'common', null, {
                coordinator: this.coordinator.id,
                date: firstDay,
            })
            .subscribe(
                (meetings: MeetingModel) => {
                    this.meetingID = meetings.meeting_setting.id;
                    this.monthSchedule = meetings.timing_blocks.map(
                        (day: any) => {
                            let dayDate =
                                this.dateHelper.getMidnightDateFromString(
                                    day.date
                                );
                            if (day.day_completed || day.hours.length == 0) {
                                this.excludedDays.push(dayDate);
                            }

                            let scheduleModel = {
                                date: dayDate,
                                dayCompleted: day.day_completed,
                                scheduleRows: day.hours.map((hours) => {
                                    return new ScheduleRange(
                                        this.dateHelper.stringToDate(
                                            day.date.toString(),
                                            hours.init
                                        ),
                                        this.dateHelper.stringToDate(
                                            day.date.toString(),
                                            hours.end
                                        ),
                                        hours.blocked ? 0 : 1
                                    );
                                }),
                            };
                            return scheduleModel;
                        }
                    );

                    if (updateUnavailableDays) {
                        this.manageExcludedDays(meetings.unavailable_dates);
                    } else {
                        this.owCalendarChild.generateMonthMatrix();
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
    }

    manageExcludedDays(data: any): void {
        data.forEach((date: any) => {
            this.excludedDays.push(
                this.dateHelper.getMidnightDateFromString(date.date_from)
            );
        });
        this.owCalendarChild.generateMonthMatrix();
    }

    selectSchedule(schedule: ScheduleRange): void {
        if (schedule.availability == 0) return;
        this.selectedRange = schedule === this.selectedRange ? null : schedule;
    }

    onDaySelected(event: Date): void {
        this.schedule = this.monthSchedule.find(
            (schedule) => schedule.date.getTime() == event.getTime()
        );
        this.selectedDay = event;
    }

    callback(): void {
        this.onArrangeDate.emit({
            meetingID: this.meetingID,
            selectedRange: this.selectedRange,
        });
        this.toggler.close();
    }
}
